import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
/**
 * Função para obter cores dos badges baseada na paleta
 */

const getBadgeVariant = value => {
  if (value === 'Sim' || value === 'Ativo') {
    return 'success';
  } else {
    return 'danger';
  }
};
/**
 * Colunas da tabela de operações usando TanStack Table
 */


export const getOperacoesColumns = () => [{
  id: 'nomeOperacao',
  header: 'Nome da Operação',
  accessorKey: 'nomeOperacao',
  size: 200,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={25} />
}, {
  id: 'tipoDaOperacao',
  header: 'Tipo da Operação',
  accessorKey: 'tipoDaOperacao',
  size: 180,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={20} />
}, {
  id: 'situacao',
  header: 'Situação',
  accessorKey: 'situacao',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TableBadge label={getValue()} variant={getBadgeVariant(getValue())} size="sm" />
}, {
  id: 'diasRecorrencia',
  header: 'Dias Recorrência',
  accessorKey: 'diasRecorrencia',
  size: 130,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue() || '-'}</span>
}, {
  id: 'recorrenciaLigada',
  header: 'Recorrência Ativa',
  accessorKey: 'recorrenciaLigada',
  size: 130,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue() ? 'Sim' : 'Não'} variant={getBadgeVariant(getValue() ? 'Sim' : 'Não')} size="sm" />
}, {
  id: 'gerarCobranca',
  header: 'Gerar Cobrança',
  accessorKey: 'gerarCobranca',
  size: 130,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue() ? 'Sim' : 'Não'} variant={getBadgeVariant(getValue() ? 'Sim' : 'Não')} size="sm" />
}, {
  id: 'dataCriacao',
  header: 'Data de Criação',
  accessorKey: 'dataCriacao',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}, {
  id: 'dataAtualizacao',
  header: 'Última Atualização',
  accessorKey: 'dataAtualizacao',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}];
